import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import AllProjects from "../components/projects/allProjects";

import INFO from "../data/user";
import SEO from "../data/seo";

// Import local images for reviews
import user1 from "../images/user1.jpg";
import user2 from "../images/user2.jpg";
import user3 from "../images/user3.jpg";
import user4 from "../images/user4.jpg";
import user5 from "../images/user5.jpg";

import "./styles/projects.css";

const Projects = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "projects");

	const reviews = [
		{
			name: "Ange Nina",
			photo: user1,
			review: "Konica Minolta Printer Repair service was excellent! My printer is now running like new. Highly recommend."
		},
		{
			name: "Jane Smith",
			photo: user2,
			review: "I bought a printer from Konica Minolta, and it's been fantastic. Great customer service and quality products!"
		},
		{
			name: "Mike cusa",
			photo: user3,
			review: "My office printer was constantly jamming, but the Konica Minolta team fixed it quickly. Reliable and professional service!"
		},
		{
			name: "Sarah Mutoni",
			photo: user4,
			review: "Konica Minolta provides excellent maintenance services. My printer has been running smoothly for months thanks to them."
		},
		{
			name: "David cesal",
			photo: user5,
			review: "If you need printer repairs or maintenance, Konica Minolta is the go-to service! Friendly, skilled, and efficient."
		}
	];

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Projects | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="projects" />
				<div className="content-wrapper">
					<div className="projects-logo-container">
						<div className="projects-logo">
							<Logo width={46} />
						</div>
					</div>
					<div className="projects-container">
						<div className="title projects-title">
							Konica Repair Services Since 2021
						</div>

						<div className="subtitle projects-subtitle">
							Konica repair services typically refer to the repair, maintenance, and troubleshooting of Konica Minolta printers and copiers. These services ensure that Konica devices operate at their optimal performance and extend their lifespan. With many years of experience, a repair service provider would likely be highly skilled in diagnosing and resolving common issues that arise with Konica Minolta machines, including printers, copiers, and multifunction devices.
						</div>

						<div className="projects-list">
							<AllProjects />
						</div>

						<div className="reviews-section">
							<h2 className="reviews-title">What People Say</h2>
							<div className="reviews-container">
								{reviews.map((review, index) => (
									<div key={index} className="review-item">
										<img src={review.photo} alt={review.name} className="review-photo" />
										<div className="review-content">
											<h3 className="review-name">{review.name}</h3>
											<p className="review-text">{review.review}</p>
										</div>
									</div>
								))}
							</div>
						</div>
					</div>

					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Projects;
